module.exports = __webpack_public_path__ + "static/img/花瓶7.aa5f442.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/papercutLamp/imgs/花瓶7.png
// module id = GVhP
// module chunks = 2